import React from 'react';
import { useNavigate } from 'react-router-dom';
import FMLogoAnimated from 'src/assets/img/FMLogoAnimated.svg';
import './index.scss';

export default function FMLoader ({ loadingMessage, noTimer }) {
  const [redirect, setRedirect] = React.useState(false);

  const navigate = useNavigate();

  React.useEffect(() => {
    let redirectTimer;
    if (noTimer) return;
    const msgTimer = setTimeout(() => {
      setRedirect(true);
      if (process.env.NODE_ENV !== 'development') {
        redirectTimer = setTimeout(() => {
          navigate('/', { replace: true });
        }, 3000);
      }
    }, 7000);
    return () => {
      // clear timer if already redirected
      clearTimeout(msgTimer);
      clearTimeout(redirectTimer);
    };
  }, [navigate, noTimer]);

  const redirectMessage = () => {
    return (
      <>
        Issue loading page, redirecting you to the homepage... {'\n'}
        <a href='/'>Click here if the page does not automatically redirect</a>
      </>
    );
  };

  return (
    <div className='fm-loader flex flex-container flex-center'>
      <img src={FMLogoAnimated} alt='Animated FM Logo' />
      {loadingMessage && <div className='loader-message'>{loadingMessage}</div>}
      {redirect && (
        <div className='loader-message pre-wrap'>{redirectMessage()}</div>
      )}
    </div>
  );
}
